<span class="inline-block font-body-1 medium-type ms-small-b" data-milestone-title>
  {{
    (isUnlocked
      ? 'LOYALTY.milestones.milestoneUnlockedAtTierPoints'
      : 'LOYALTY.milestones.milestoneUnlockWithTierPoints'
    ) | finLocalization: { tierPoints: content.localSettings.milestonePoints | finPoints }
  }}
</span>

<div class="milestone-card flex grow border rounded-large">
  <div class="image-wrapper flex--nogrow relative rounded-left-large overflow-hidden">
    <fcom-image [imageData]="content | finMap: 'media.0'" [fillParent]="true" [scale]="false"></fcom-image>
    <div
      class="milestone-ribbon font-body-1 bold-type absolute flex flex--center ps-small-y ps-medium-x rounded-bottom-right-large"
      [ngClass]="{ 'success-50-bg success-900-text': isUnlocked, 'grey-200-bg grey-600-text': !isUnlocked }"
      data-milestone-card-ribbon
    >
      <fcom-icon
        class="icon-medium"
        [name]="isUnlocked ? SvgLibraryIcon.LOCK_OPEN : SvgLibraryIcon.LOCK_CLOSED"
      ></fcom-icon>

      <span data-milestone-card-ribbon-title>{{
        (isUnlocked ? 'LOYALTY.milestones.milestoneUnlocked' : 'LOYALTY.milestones.milestoneLocked') | finLocalization
      }}</span>
    </div>
  </div>

  <div class="font-body-1 bold-type ms-medium milestone-details flex">
    <span
      class="ms-medium-b inline-block"
      [innerHTML]="content.teaserTitle | finSafe: 'html'"
      data-milestone-card-teaser-title
    ></span>
    <span
      class="font-body-1 regular-type inline-block"
      [innerHTML]="content.detailText | finSafe: 'html'"
      data-milestone-card-detail-text
    ></span>
  </div>
</div>
